import React from "react";
import { profileIconDefault } from "../../../assets/logos/icons";
import { PanelBarGLPure, GridSelectionHLPure } from "../../pures";
import { Grid, useMediaQuery } from '@material-ui/core';
import "./consult-negotiation-changes.css";

const ConsultNegotationChangesView = (props) => {
    let {
        changes,
        t
    } = props

    const is960px = useMediaQuery("(max-width:960px)");

    let heightGrid = '320px'

    if(changes.length === 1 || changes.length === 0){
        heightGrid = '140px'
    }else if(changes.length === 2){
        heightGrid = '240px'
    }else if(changes.length === 3){
        heightGrid = '340px'
    }else{
        heightGrid = '430px'
    }

    
    const headerColumnTwo = (props) => {
        return <span className="consultNegotationChangesView-header-cell-two">{props.title}</span>;
    };
    
    const headerColumnThree = (props) => {
        return <span className="consultNegotationChangesView-header-cell-three">{props.title}</span>;
    };

    const cellColumnOne = (props) => {
        return (
            <td className='consultNegotationChangesView-cell-one'>
                <div className="gridSimpleReadHLPure-imageAvatar">
                    <img
                        alt="profile-img"
                        src={props.dataItem.profilePicture || profileIconDefault}
                        className="consultNegotationChangesView-avatar"
                    />
                </div>
            </td>
        )
    }

    const cellColumnTwo = (props) => {
        return (
            <td className='consultNegotationChangesView-cell-two'>
                <div className="consultNegotationChangesView-container-usernames">
                    <span className="consultNegotationChangesView-username">
                        {props.dataItem.userName}
                    </span>
                    <span className="consultNegotiation-details">
                        {props.dataItem.text}
                    </span>
                </div>
            </td>
        );
    };

    
    const cellColumnThree = (props) => {
        return (
            <td className='consultNegotationChangesView-cell-three'>
                <div className="container-grid-subtitle">
                    <span className="grid-subtitle">
                        {props.dataItem.action}
                    </span>
                    <span className="grid-subtitle">
                        {props.dataItem.createdDate}
                    </span>
                    <span className={(props.dataItem.status === t("consultNegotiation.status.contract.accepted")) ? "grid-subitle-green" : "grid-subitle-black" }>
                        {props.dataItem.status}
                    </span>
                </div>
            </td>
        );
    };

    return (
        <PanelBarGLPure
            expandedPanel={true}
            titlePanel={t("consultNegotiation.panels.bar.title.changes")}
            className='consultNegotationChangesView'
        >
            <Grid item className="consultNegotationChangesView-grid-documents">
                <GridSelectionHLPure
                    styleGeneral={true}
                    styleGeneralClass={"consultNegotationChangesView-general-grid"}
                    pageable={false}
                    skip={0}
                    take={changes.length}
                    dataGrid={changes}
                    filter={false}
                    columnOne={(!is960px) ? true : false}
                    columnTwo={true}
                    columnThree={true}
                    titleRow2={t("consultNegotiation.changes.grid.title.1")}
                    titleRow3={t("consultNegotiation.changes.grid.title.2")}
                    headerColumnTwo={headerColumnTwo}
                    headerColumnThree={headerColumnThree}
                    cellColumnOne={cellColumnOne}
                    cellColumnTwo={ cellColumnTwo }
                    cellColumnThree={ cellColumnThree }
                    styleGrid={{ height: heightGrid }}
                />
            </Grid>            
        </PanelBarGLPure>
    )
}

export { ConsultNegotationChangesView as default}